export default {
  options (h, conf, key, child) {
    const list = []
    const isEditMode = this.mode === 'fastSite'
    const changeKey = '__slot__.options'
    conf.__slot__.options.forEach((tab, index) => {
      const sty = {
        fontSize: tab.size,
        color: tab.color
      }
      const iconSty = {
        ...sty,
        marginRight: '8px'
      }
      list.push(
        <el-tab-pane
          disabled={tab.disabled}
          name={tab.name}
          closable={tab.closable}
          style={{ 'max-width': conf.maxWidth, overflow: 'hidden', margin: '0px auto' }}
          lazy
        >
          <template slot="label">
            {tab.icon ? <i class={tab.icon} style={iconSty}></i> : ''}
            {/* <span class="mobile-tab-title" style={sty}>{ tab.label }</span> */}
            <span class="mobile-tab-title" style={sty}>
              <TextEdit
                style={{ display: tab.icon ? 'inline-block' : 'block' }}
                change-key={changeKey}
                v-model={tab.label}
                mode={isEditMode}
                isSingle={false}
                sendData={conf.__slot__.options}
                {...{ on: this.$listeners }}
              />
            </span>
          </template>
          {child}
        </el-tab-pane>
      )
    })
    return list
  }
}
